<header class="navbar navbar-expand-lg bg-white shadow-sm position-relative compact-navbar">
  <div class="container-fluid">
    <!-- Hamburger Menu for Small Screens -->
    <button
      class="navbar-toggler"
      type="button"
      (click)="showSidebar = true"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Logo -->
    <a class="nav-brand ms-3 " (click)="navigateToHome()">
      <img
        src="../../../assets/images/SmartDukaan_Logo_Transparent.png"
        alt="SmartDukaan Logo"
        class="brand-logo compact-logo"
        loading="lazy"
        style="width: 110px"
      />
    </a>

    <!-- Delivery Option (Responsive for Both Small and Large Screens) -->
    <div class="nav-location">
      <button
        class="btn btn-link text-danger p-2 d-flex align-items-center text-decoration-none"
        (click)="visible = true"
      >
        <!-- Icon -->
        <i class="pi pi-map-marker me-2" style="font-size:1.65rem"></i>
        <!-- Pincode Text -->
        <div class="d-none d-lg-flex flex-column justify-content-start">
          <small class="text-uppercase fs-12">Deliver to</small>
          <strong class="text-start">{{ pincode }}</strong>
        </div>
        <!-- Pincode Text for Small Screens -->
        <div class="d-lg-none d-flex flex-column justify-content-start" >
          <small class="text-uppercase">Deliver to</small>
          <strong class="text-start">{{ pincode }}</strong>
        </div>
      </button>
    </div>

    <!-- Main Navigation (Desktop) -->
    <div class="collapse navbar-collapse" id="navbarNav">
      <!-- Search Bar - Desktop -->
      <div class="mx-lg-4 flex-grow-1 d-none d-lg-block">
        <div class="input-group search-bar">
          <input
            type="search"
            class="form-control"
            [(ngModel)]="searchText"
            placeholder="Search smartphones, accessories..."
            (keydown.enter)="querySearch()"
          />
          <button class="btn btn-danger" type="button" (click)="querySearch()">
            <i class="pi pi-search"></i>
          </button>
        </div>
      </div>

      <!-- Navigation Links - Desktop -->
      <div class="d-none d-lg-flex align-items-center">
        <a href="javascript:void(0)" (click)="openUrl('https://franchise.smartdukaan.com')" class="text-decoration-none mx-3">
          <button class="btn btn-sm btn-outline-danger btn-partner">
            <i class="pi pi-briefcase me-2"></i> Become Franchise Partner
          </button>
        </a>
        <a *ngIf="!customer?.smartSeller" href="javascript:void(0)" (click)="smartSeller()" class="text-decoration-none mx-3">
          <button class="btn btn-sm btn-outline-danger btn-partner">
            <i class="pi pi-briefcase me-2"></i> Become Smart Seller
          </button>
        </a>
        <div class="dropdown">
          <button class="btn btn-link text-dark" type="button" id="userMenu" data-bs-toggle="dropdown">
            <i class="pi pi-user fs-4"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end">
            <li *ngIf="isLoggedIn()"><a class="dropdown-item-text" [routerLink]="['/user/profile']">Profile</a></li>
            <li *ngIf="isLoggedIn()"><hr class="dropdown-divider" /></li>
            <li *ngIf="isLoggedIn()&&customer?.smartSeller"><a class="dropdown-item-text" [routerLink]="['/associates/dashboard']">Smart Seller</a></li>
            <li *ngIf="isLoggedIn()&&customer?.smartSeller"><hr class="dropdown-divider" /></li>
            <li *ngIf="isLoggedIn(); else signInOption">
              <a class="dropdown-item-text" href="#" (click)="logOut()">Logout</a>
            </li>
          </ul>
        </div>
        <button class="btn btn-link text-dark position-relative mx-2" [routerLink]="['/cart']">
          <i class="pi pi-shopping-cart fs-4"></i>
          <span *ngIf="cart?.length > 0" class="position-absolute top-0 start-50 translate-middle badge rounded-pill bg-danger">
            {{ cart?.length }}
          </span>
        </button>
      </div>
    </div>
    <ng-template #signInOption>
      <li>
        <a class="dropdown-item-text" [routerLink]="['/auth']">Sign In</a>
      </li>
      <li><hr class="dropdown-divider" /></li>
      <li>
        <a class="dropdown-item-text" [routerLink]="['/auth']">Sign Up</a>
      </li>
    </ng-template>
    <!-- Mobile Search Bar -->
    <div class="d-lg-none w-100 d-flex align-items-center px-1 mt-1 flex-grow-1 mb-2">
      <a role="button" class="d-lg-none me-2 text-decoration-none" (click)="goBack()" *ngIf="!isHomePage" >
        <button class="btn btn-link text-danger p-1">
          <i class="pi pi-angle-left" style="font-size: 1.5rem"></i>
        </button>
      </a>
      <div class="input-group">
        <input
          type="search"
          class="form-control"
          [(ngModel)]="searchText"
          placeholder="Search products..."
          (keydown.enter)="querySearch()"
        />
        <button class="btn btn-danger" type="button" (click)="querySearch()">
          <i class="pi pi-search"></i>
        </button>
      </div>
    </div>
  </div>
</header>

<hr class="d-none d-md-block" style="margin: 0">
<nav class="navbar bg-body-tertiary d-none d-md-block" *ngIf="nevMenu?.length">
  <div class="container">
    <div class="d-none d-md-flex w-100 justify-content-center">
      <ul class="navbar-nav flex-row scrollable-menu">
        <li class="nav-item text-center" *ngFor="let menu of nevMenu; let i = index">
          <a class="nav-link button px-2 "
             [routerLink]="menu.link"
             (click)="makeActive(i)"
             [ngClass]="{'active-menu': activeIndex === i}">
            {{ menu.title }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<hr class="d-none d-md-block" style="margin: 0">
<!-- Collapsible Navigation Menu -->
<p-sidebar
  [(visible)]="showSidebar"
  position="left"
  [modal]="true"
  [showCloseIcon]="false"
  class="filter-sidebar"
>
  <ng-template pTemplate="header">
    <div class="d-flex justify-content-center align-items-center" style="width: 100%;">
    <span class="font-semibold text-xl">
      <img src="../../../assets/images/SmartDukaan_Logo_Transparent.png"
           alt="SmartDukaan Logo" class="brand-logo compact-logo" loading="lazy" style="width: 110px"/>
    </span>
      <span class="close" (click)="showSidebar = false">
      <i class="pi pi-times"></i>
    </span>
    </div>
  </ng-template>
  <!-- Scrollable Menu Content -->
  <div class="sidebar-content">
    <ul class="list-group list-group-flush">
      <li class="list-group-item">
        <a href="javascript:void(0)" (click)="openUrl('https://franchise.smartdukaan.com')" class="text-decoration-none mx-3">
          <button class="btn btn-sm btn-outline-danger btn-partner w-90">
            <i class="pi pi-briefcase me-2"></i> Become Franchise Partner
          </button>
        </a>
      </li>
      <li class="list-group-item">
        <a *ngIf="!customer?.smartSeller" href="javascript:void(0)" (click)="smartSeller()" class="text-decoration-none mx-3">
          <button class="btn btn-sm btn-outline-danger btn-partner w-90">
            <i class="pi pi-briefcase me-2"></i> Become Smart Seller
          </button>
        </a>
      </li>
      <li
        class="list-group-item d-flex justify-content-between align-items-center"
        *ngFor="let menu of nevMenu; let i = index"
        [ngClass]="{'active': activeIndex === i}"
        [routerLink]="menu.link"
        (click)="makeActive(i); showSidebar = false">
        {{ menu.title }}
        <i class="pi pi-angle-right text-muted"></i>
      </li>
    </ul>
  </div>
</p-sidebar>
<p-dialog header="Select Your Location" [modal]="true" [(visible)]="visible" [style]="{ width: '30rem' }"
          [breakpoints]="{'960px': '100vw'}">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="subtitle">To check products & delivery options available at your location</div>
        <form class="delivery-form mt-4">
          <div class="input-group mb-3">
            <input type="search" [(ngModel)]="pincode" class="form-control" pattern="[0-9]{6}" maxlength="6"
                   placeholder="Enter a delivery pincode" required>
            <div class="input-group-append">
              <button class="btn btn-danger" type="button" (click)="changePinCode()">Check</button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="stores-list">
          <div *ngFor="let st of stores" class="store-item">
            <div class="form-check">
              <input class="form-check-input" type="radio" id="store-{{st.code}}" (click)="getStore(st.code)"
                     [checked]="selectedStoreCode === st.code"/>
              <label class="form-check-label" for="store-{{st.code}}">
                <div class="store-info">
                  <span class="store-name" style="color:#d3181f;">{{st.businessName}}</span>
                  <span class="store-address"
                        style="font-size:12px;">({{st.address.line1 + ' ' + st.address.line2 + ' ' + st.address.city}}
                    )</span>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
